import UpdateSleepStoryTranslationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryTranslationRequest";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";


export default class SleepStoryTranslateViewModel {
    langCode?: string = '';
	name?: string = '';
	description?: string = '';
	voiceFile: MeditationAudioViewModel = null;
    constructor(obj?: Partial<SleepStoryTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): UpdateSleepStoryTranslationRequest {
        const res = new UpdateSleepStoryTranslationRequest({
            Description: this.description,
            LangCode: this.langCode,
            Name: this.name,
            VoiceFile: this.voiceFile ? this.voiceFile.toServerModel() : null
        });
        return res;
    }
}
